import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../utils/apiInterceptor';
import { API_BASE_URL } from '../../utils/paths';

// spots/all/forecast
export const fetchSavedSpotsLiveData = createAsyncThunk(
  'forecast/fetchSavedSpotsLiveData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiFetch(`${API_BASE_URL}/spots/all/live`, {
        method: 'GET',
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue({ message: error.message });
    }
  }
);

const liveDataSlice = createSlice({
    name: 'liveData',
    initialState: {
        spots: {},
        isLoading: false,
        errors: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSavedSpotsLiveData.pending, (state) => {
                state.isLoading = true;
                state.errors = null;
            })
            .addCase(fetchSavedSpotsLiveData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.spots = action.payload;
            })
            .addCase(fetchSavedSpotsLiveData.rejected, (state, action) => {
                state.isLoading = false;
                state.errors = action.payload || { message: 'Failed to fetch all spots live data' };
            });
    }
});

export default liveDataSlice.reducer